import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  withArrow?: boolean;
  fullWidth?: boolean;
  href?: string;
  target?: string;
  rel?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  withArrow = false,
  fullWidth = false,
  href,
  target,
  rel,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-300 rounded-2xl';
  const variants = {
    primary: 'bg-terracotta hover:bg-terracotta-dark text-white shadow-soft hover:shadow-lg hover:-translate-y-1',
    secondary: 'bg-sage hover:bg-sage-dark text-white shadow-soft hover:shadow-lg hover:-translate-y-1',
    outline: 'border-2 border-sage text-sage-dark hover:bg-sage hover:text-white'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  const content = <>
      {children}
      {withArrow && <ArrowRight className="ml-2 w-5 h-5" data-id="element-37" />}
    </>;
  if (href) {
    return <a href={href} target={target ?? '_blank'} rel={rel ?? 'noopener noreferrer'} className={combinedClassName} data-id="element-38">
        {content}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-39">
      {content}
    </button>;
}